<template>
  <div id="footer">
    <div class="top">
      <div class="scheme">
        <div class="title">首页</div>
        <p @click="toHome">公司简介</p>
        <p @click="toHome">主营业务</p>
        <p @click="toHome">资质证书</p>
      </div>
      <div class="purchase">
        <div class="title">证书及荣誉</div>
        <p @click="toZs(0)">营业执照</p>
        <p @click="toZs(1)">资质证书</p>
        <p @click="toZs(2)">荣誉证书</p>
      </div>
      <div class="support">
        <div class="title">主营业务</div>
        <p @click="toYw(0)">电力运营维护</p>
        <p @click="toYw(1)">设备代理</p>
        <p @click="toYw(2)">电力工程</p>
      </div>
      <div class="know">
        <div class="title">联系我们</div>
        <p @click="toContact">咨询服务</p>
        <p @click="toContact">加入我们</p>
        <p @click="toContact">公司地址</p>
      </div>
      <div class="gzh">
        <img
          src="../assets/img/gzh.png"
          alt=""
        >
        <div class="gzh-text">公众号</div>
      </div>
    </div>
    <div class="bottom">
      <!-- <div class="oneline">鄂公安备&nbsp;2022020025号</div> -->
      <div class="twoline"><a class="beian" href="https://beian.miit.gov.cn" target="blank">鄂ICP备2023015585号</a></div>
      <div class="twoline">Copyright&nbsp;湖北国弘电力股份有限公司&nbsp;All&nbsp;Right&nbsp;Reserved</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    // 去到主营业务
    toYw(i) {
      if (i == 0) {
        this.$router.push("/companyintroduction");
      }
      if (i == 1) {
        this.$router.push({
          path: "/companyintroduction",
          query: {
            i: i,
          },
        });
      }
      if (i == 2) {
        this.$router.push({
          path: "/companyintroduction",
          query: {
            i: i,
          },
        });
      }
    },
    // 去到证书及荣誉
    toZs(i) {
      if (i == 0) {
        this.$router.push("/service");
      }
      if (i == 1) {
        this.$router.push({
          path: "/service",
          query: {
            i: i,
          },
        });
      }
      if (i == 2) {
        this.$router.push({
          path: "/service",
          query: {
            i: i,
          },
        });
      }
    },
    // 去首页
    toHome() {
      this.$router.push("/home");
    },
    toContact() {
      this.$router.push("/contactus");
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  #footer {
    height: 150px !important;
  }
  .bottom {
    .oneline {
      font-size: 10px !important;
    }
    .twoline {
      font-size: 10px !important;
      -webkit-transform: scale(0.8);
      font-weight: normal !important;
    }
  }
  .top {
    padding: 0 !important;
    .scheme,
    .purchase,
    .support,
    .know,
    .gzh {
      & > p {
        font-size: 10px !important;
        -webkit-transform: scale(0.8);
        font-weight: normal !important;
        margin-bottom: 3px !important;
      }
      .title {
        font-size: 10px !important;
        padding-bottom: 10px !important;
      }
      & > img {
        width: 45px !important;
      }
      .gzh-text {
        font-size: 10px;
      }
    }
  }
}
#footer {
  width: 100%;
  height: 240px;
  background-color: #134e99;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .beian{
    color: #fff;
  }
  .beian:hover {
    color: #ec722e;
    cursor: pointer;
  }
  .top {
    flex: 3;
    width: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    // justify-content: center;
    padding: 0 15%;
    box-sizing: border-box;
    .scheme,
    .purchase,
    .support,
    .know,
    .gzh {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: start;
      justify-content: center;
      .title {
        font-size: 16px;
        color: #fff;
        padding: 0 0 8% 0;
        box-sizing: border-box;
      }
      .title:hover {
        color: #fff;
      }
      p {
        padding-bottom: 5px;
        box-sizing: border-box;
        font-size: 12px;
        cursor: pointer;
        color: #fff;
      }
      p:hover {
        color: #ec722e;
      }
    }
    .gzh {
      & > img {
        width: 95px;
      }
      .gzh-text {
        padding-top: 5px;
        box-sizing: border-box;
      }
    }
  }
  .bottom {
    box-sizing: border-box;
    font-size: 12px;
    width: 100%;
    flex: 1;
    text-align: center;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue